import React from 'react'
import { ChevronLeft } from 'lucide-react';

export default function BackButton() {
  return (
    <div className='d-flex flex-row align-items-center ' 
    style={{cursor:'pointer' , marginLeft:'-7px'}}
    onClick={()=>window.history.back()} >
            <ChevronLeft />
            <h6 className='m-0' >Back</h6>
    </div>
  )
}
